import React from 'react';
import PageTitle from '../components/PageTitle';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import ButtonContainer from '../components/ButtonContainer';
import TallButton from '../components/TallButton';
import messages from './MigrateAccountConfirmationPage.messages';
import WhiteboxPage from '../components/WhiteboxPage';
import { lookupApplication } from '../utilities/applications';
import {
  useButtonClickedEvent,
  usePageViewedEvent,
} from '../utilities/analytics/analytics-web-client';
import { useAppSelector } from '../stores/redux.store';
import { useNavigateSoftOrHard } from '../utilities/hooks/useNavigateSoftOrHard';
import { fetchPageState } from '../utilities/fetch-api';
import Heading from '@atlaskit/heading';

const MigrateAccountConfirmationSubHeading = styled.p`
  font: ${token('font.body')};
  margin-top: ${gridSize()}px;
`;

const pageId = 'accountMigrationSuccessfulScreen';

export async function migrateConfirmationLoader({ request }: { request: Request }) {
  return await fetchPageState('/rest/signup/migrate-confirmation/state', request, {
    capabilities: [], // TODO: determine if account migration is a capability; tag approrpriately if it is
  });
}

export const MigrateAccountConfirmationPage = () => {
  const redirectTo = useAppSelector(state => state.migrateConfirmation.redirectTo);

  const [searchParams] = useSearchParams();
  const { formatMessage } = useIntl();
  const navigate = useNavigateSoftOrHard();

  const migratingUserInfoCode = searchParams.get('infoCode');
  const pageViewedAttributes = migratingUserInfoCode
    ? {
        reasonViewingScreen: migratingUserInfoCode,
      }
    : {};

  usePageViewedEvent(pageId, pageViewedAttributes);

  const trackContinueToProduct = useButtonClickedEvent(pageId, 'continueToProduct');

  const handleOnClick = () => {
    trackContinueToProduct();
    navigate(redirectTo);
  };

  const applicationData = lookupApplication(searchParams);
  const productDisplayName = applicationData?.name || 'Product';

  return (
    <WhiteboxPage
      pageId={pageId}
      header={
        <Heading as="h1" size="small">
          <FormattedMessage {...messages.migrateAccountConfirmationTitle} />
        </Heading>
      }>
      <MigrateAccountConfirmationSubHeading>
        <FormattedMessage
          {...messages.migrateAccountConfirmationSummaryText}
          values={{
            productDisplayName,
          }}
        />
      </MigrateAccountConfirmationSubHeading>

      <ButtonContainer>
        <TallButton
          appearance="primary"
          id="continue-submit"
          type="submit"
          isFullWidth
          onClick={handleOnClick}>
          <FormattedMessage
            {...messages.migrateAccountConfirmationButtonText}
            values={{ productDisplayName }}
          />
        </TallButton>
      </ButtonContainer>
      <PageTitle title={formatMessage(messages.headTitle)} />
    </WhiteboxPage>
  );
};

export default MigrateAccountConfirmationPage;
